const TOKEN_STORAGE_KEY = "mini-market.id_token";
const COGNITO_SCOPE = process.env.REACT_APP_COGNITO_SCOPE || "openid email profile";

export function getTokenStorageKey() {
  return TOKEN_STORAGE_KEY;
}

export function decodeJwtPayload(token) {
  const payload = token.split(".")[1] || "";
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = `${base64}${"=".repeat((4 - (base64.length % 4)) % 4)}`;
  return JSON.parse(atob(padded));
}

export function isTokenExpired(token) {
  try {
    const payload = decodeJwtPayload(token);
    if (!payload.exp) {
      return false;
    }
    return payload.exp * 1000 <= Date.now();
  } catch (_err) {
    return true;
  }
}

export function readTokenFromUrlHash() {
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : "";
  const params = new URLSearchParams(hash);
  return params.get("id_token");
}

function buildCognitoUrl(domain, path, clientId, redirectUri) {
  if (!domain || !clientId || !redirectUri) {
    return "";
  }

  const params = new URLSearchParams({
    response_type: "token",
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: COGNITO_SCOPE,
  });

  return `https://${domain}${path}?${params.toString()}`;
}

export function buildLoginUrl(domain, clientId, redirectUri, identityProvider = "") {
  const url = buildCognitoUrl(domain, "/oauth2/authorize", clientId, redirectUri);
  if (!url || !identityProvider) {
    return url;
  }

  const nextUrl = new URL(url);
  nextUrl.searchParams.set("identity_provider", identityProvider);
  return nextUrl.toString();
}

export function buildSignupUrl(domain, clientId, redirectUri) {
  return buildCognitoUrl(domain, "/signup", clientId, redirectUri);
}

export function buildLogoutUrl(domain, clientId, logoutUri) {
  if (!domain || !clientId || !logoutUri) {
    return "";
  }

  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: logoutUri,
  });

  return `https://${domain}/logout?${params.toString()}`;
}
